(function ( $ ) {

	$.fn.streetAutocomplete = function(zipCodeInput, cityNameInput, streetInput) {

		var $streetInput=$(streetInput);
		var $zipCodeInput=$(zipCodeInput);
		var $cityNameInput=$(cityNameInput);

		var $streetList=$('<ul class="street-autocomplete-list list-empty"></ul>').insertAfter($streetInput);

		var xhr;
		var cache=[];

		function selectOption(element){
			$streetInput.val(element.text());
			$streetInput.trigger('keyup');
			hideOptionList();
		}
		function init() {
			$('body').one('click.streetAutocomplete',function(event){
				var isAutocompleteField = $(event.target).data('street-autocomplete')==true;
				if(!isAutocompleteField){
					clearOptionList();
					$('html').removeClass('street-autocomplete-active');
				}
			});

			$streetList.on('click', '.street-name-list-item', function(){
				selectOption($(this));
			});

			$streetInput.on('focusin', function () {
				this.select();
			});

			$streetInput.data('street-autocomplete',true).attr({
				spellcheck:"false",
				autocapitalize:"off",
				autocorrect:"off",
				autocomplete:"off"
			}).on('keydown focus paste', function(event){
				var key = event.keyCode,
					$listItems = $streetList.find('li:not(.street-name-list-item-hidden)');

				if($(this).val().length < 3) {
					clearOptionList();
					return;
				}
				if(key>=37 && key<=40){
					return;
				}
				if(typeof cache[$streetInput.val()] !== "undefined" && $listItems.length) {
					filterList();
				}else {
					getList();
				}
			});
		}

		function clearOptionList() {
			$streetList.html('');
		}
		function getList() {
			abortAjax();
			var cacheElement=''+$cityNameInput.val()+$zipCodeInput.val()+$streetInput.val();
			if(typeof cache[cacheElement] !== "undefined"){
				buildList(cache[cacheElement]);
			}else{
				$streetInput.addClass('street-autocomplete-loading');
				xhr = $.ajax({
					method: 'GET',
					contentType: 'application/json',
					dataType: 'text',
					url: '/streetAutocomplete.ltr',
					data: {
						street: $streetInput.val(),
						city: $cityNameInput.val(),
						zipCode: $zipCodeInput.val()
					},
					success: function(response){
						response=JSON.parse(response);
						cache[cacheElement]=response;
						buildList(response);
					},
					complete: function() {
						$streetInput.removeClass('street-autocomplete-loading');
					}
				});
			}
		}
		function buildList(list) {
			clearOptionList();
			$.each(list, function(i, val) {
				$streetList.append($('<li>', { class:'street-name-list-item', text: val }));
			});
			if(list.length){
				showOptionList();
			}
		}
		function abortAjax() {
			if(xhr && xhr.readystate != 4){
				xhr.abort();
			}
			$streetInput.removeClass('city-autocomplete-loading');
			hideOptionList();
		}
		function filterList() {
			$cityList.find('.street-name-list-item').each(function(i, val){
				if(!$(this).text().trim().toLowerCase().startsWith($streetInput.val().toLowerCase())) {
					$(this).addClass('street-name-list-item-hidden');
				} else {
					$(this).removeClass('street-name-list-item-hidden');
					var val = $streetInput.val();
					var text = $(this).text().trim();
					$(this).html(text.replace(new RegExp('(' + val + ')', 'gi'), '<b>$1</b>'));
				}
			});
			if($streetList.find('.street-name-list-item-hidden').length === $streetList.find('.city-name-list-item').length){
				hideOptionList();
			}
			else {
				showOptionList();
			}
		}
		function hideOptionList() {
			$streetList.addClass('list-empty');
			$('html').removeClass('street-autocomplete-active');
		}
		function showOptionList() {
			$streetList.removeClass('list-empty');
			$('html').addClass('street-autocomplete-active');
		}
		init();
	}

	$.fn.streetUnautocomplete = function(streetInput) {
		let $streetInput = $(streetInput);
		let $streetList = $streetInput.next();

		$streetList.off('click');
		$streetInput.off('keydown focus paste');

		// Remove attributes and classes added by this plugin
		$streetInput.removeData('street-autocomplete').removeClass('street-autocomplete-loading');

		// Remove additional elements added by this plugin
		$streetList.remove();

		// Remove any active classes related to the plugin
		$('html').removeClass('street-autocomplete-active');
	}
	$.streetAutocomplete=$(window).streetAutocomplete;
	$.streetUnautocomplete=$(window).streetUnautocomplete;
}(jQuery));
